var _defaultValues;
import { DURATION } from "./field-names";
import { SubscriptionDuration } from "../../../../util/subscription/enums";
export var defaultValues = (_defaultValues = {}, _defaultValues[DURATION] = SubscriptionDuration.ONE_YEAR, _defaultValues);
